import * as React from 'react';

import Plane16 from './Plane16';

export const plane16 = () => <Plane16 />;

export default {
    title: 'Icon/Line/Plane16',
    component: Plane16,
    parameters: {
        notes: "`import Plane16 from 'box-ui-elements/es/icon/line/Plane16';`",
    },
};
